/* eslint camelcase: ["off"] */
import React, { Component } from 'react';
import { map } from 'lodash';
import Calendar from 'rc-year-calendar';
import ModalBody from '../modal/ModalBody';
import ModalHeader from '../modal/ModalHeader';

type Props = {
  opened?: boolean | null;
  userId?: number | null;
  onCloseModal: () => any;
  vacations: {
    used_vacation_dates: Array<any>;
  };
  year: string;
};

class VacationModal extends Component<Props> {
  getDatesAsDateSourse = (dates: Array<any>) => map(dates, (e => ({
    startDate: new Date(e.date), endDate: new Date(e.date), color: '#28a745', date: e.date,
  })));

  render(): React.ReactNode {
    const {
      onCloseModal, userId, opened, vacations, year,
    } = this.props;
    const classesModal = opened ? 'modal fade show d-block client-vacations-modal' : 'modal client-vacations-modal';
    const classesBackdrop = opened ? 'modal-backdrop show' : '';

    return (
      <>
        <div className={classesModal} id={String(userId)} tabIndex={-1} role="dialog" aria-labelledby={String(userId)} aria-hidden="true" data-keyboard="false" data-backdrop="static">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalHeader onCloseClick={onCloseModal} title="Vacation days" />
              <ModalBody>
                <Calendar
                  dataSource={this.getDatesAsDateSourse(vacations.used_vacation_dates)}
                  year={year}
                  weekStart={1}
                   
                  style="background"
                  displayDisabledDataSource
                  displayHeader={false}
                />
              </ModalBody>
            </div>
          </div>
        </div>
        <div className={classesBackdrop} />
      </>
    );
  }
}

export default VacationModal as React.ComponentType<Props>;
